<template>
  <div class="container">
    <div class="questions">
      <!-- Si pas de valeur dans les questions Première question -->
      <div class="question1">
        <p>À quand remonte le dernier rapport sexuel à risque?</p>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedMoinsQuest1,
              'btn-blue': getClickedMoinsQuest1,
            }"
            @click="sendMoinsQuestion1('moins')"
          >
            Moins de 72h
          </button>
          <button
            :class="{
              btn: !getClickedPlusQuest1,
              'btn-blue': getClickedPlusQuest1,
            }"
            @click="sendPlusQuestion1('plus')"
          >
            Entre 72h et 120h
          </button>
        </div>
      </div>
      <!-- Si valeur dans la question 1 mais que c'est pas la question 3 appel de la question 2 -->
      <div v-if="getMyQuestions.question2.question" class="question2">
        <p>
          {{ getMyQuestions.question2.question }}
        </p>
        <span v-if="getMyQuestions.question2.span">{{
          getMyQuestions.question2.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest2,
              'btn-blue': getClickedYesQuest2,
            }"
            @click="
              sendYesQuestion2('YES');
              scrollToElement(2);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest2,
              'btn-blue': getClickedNoQuest2,
            }"
            @click="
              sendNoQuestion2('NO');
              scrollToElement(2);
            "
          >
            NON
          </button>
        </div>
      </div>
      <!-- Si valeur dans la question 1 mais que c'est pas la question 3 appel de la question 2 -->
      <div v-if="getMyQuestions.question3.question" class="question2">
        <p>{{ getMyQuestions.question3.question }}</p>
        <span v-if="getMyQuestions.question3.span">{{
          getMyQuestions.question3.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest3,
              'btn-blue': getClickedYesQuest3,
            }"
            @click="
              sendYesQuestion3('YES');
              scrollToElement(3);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest3,
              'btn-blue': getClickedNoQuest3,
            }"
            @click="
              sendNoQuestion3('NO');
              scrollToElement(3);
            "
          >
            NON
          </button>
        </div>
      </div>
      <!-- Si valeur dans la question 4  -->
      <div v-if="getMyQuestions.question4.question" class="question2">
        <p>{{ getMyQuestions.question4.question }}</p>
        <span v-if="getMyQuestions.question4.span">{{
          getMyQuestions.question4.span
        }}</span>
        <div class="buttons">
          <button
            :class="{
              btn: !getClickedYesQuest4,
              'btn-blue': getClickedYesQuest4,
            }"
            @click="
              sendYesQuestion4('YES');
              scrollToElement(4);
            "
          >
            OUI
          </button>
          <button
            :class="{
              btn: !getClickedNoQuest4,
              'btn-blue': getClickedNoQuest4,
            }"
            @click="
              sendNoQuestion4('NO');
              scrollToElement(4);
            "
          >
            NON
          </button>
        </div>
      </div>
      <!-- Affichage du resultat -->
      <div v-if="getResult" class="result">
        <hr class="line" />
        <p>{{ getResult }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapGetters("Algo4Module", [
      "getMyQuestions",
      "getResult",
      "getClickedPlusQuest1",
      "getClickedMoinsQuest1",
      "getClickedYesQuest2",
      "getClickedNoQuest2",
      "getClickedYesQuest3",
      "getClickedNoQuest3",
      "getClickedYesQuest4",
      "getClickedNoQuest4",
    ]),
  },
  methods: {
    ...mapActions("Algo4Module", [
      "sendMoinsQuestion1",
      "sendPlusQuestion1",
      "sendYesQuestion2",
      "sendNoQuestion2",
      "sendYesQuestion3",
      "sendNoQuestion3",
      "sendYesQuestion4",
      "sendNoQuestion4",
    ]),
    scrollToElement(val) {
      setTimeout(function () {
        const el = document.getElementsByClassName("buttons")[val];
        const result = document.getElementsByClassName("result")[0];
        if (el && !result) {
          // Use el.scrollIntoView() to instantly scroll to the element
          el.scrollIntoView({ behavior: "smooth", block: "end" });
        } else result.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 100);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/variables/colors.scss";
@import "@/assets/styles/scss/variables/mixin.scss";
.container {
  width: 90%;
  padding: 0 0 0 18px;
  margin-top: 37px;
  .title {
    text-align: left;
    width: 202px;
    h2 {
      font-weight: 500;
      font-size: 29px !important;
      color: $primary;
      font: normal;
      line-height: 35px;
    }
  }
  .questions {
    margin-top: 35px;
    margin-bottom: 20px;
    p {
      font-size: 21px;
      color: $text-color-aigm;
    }
    .buttons {
      margin-top: 50px;
      display: flex;
      justify-content: space-around;
      .btn {
        position: relative;
        font-size: 12px !important;
        width: 40%;
        text-align: center;
        margin: 0 auto;
        padding: 16px !important;
        @include button($backround-grey-aigm, $text-color-aigm);
      }
      .btn-blue {
        position: relative;
        font-size: 12px !important;
        width: 40%;
        text-align: center;
        margin: 0 auto;
        padding: 16px !important;
        @include button($primary, $white-aigm);
      }
    }
  }
  .question2 {
    margin-top: 25px;
    margin-bottom: 30px;
    span {
      font-size: 14px;
      color: $text-color-aigm;
    }
  }
  .result {
    margin-top: 35px;
    margin-bottom: 30px;
    hr {
      border-top: 3px solid $primary;
    }
    p {
      font-size: 21px;
      color: $primary;
      font-weight: 600;
    }
  }
}
</style>
